<template>
  <div class="basicItem-wrap">
    <span class="basicItem-label">{{label}}</span>
    <slot>
      <span>{{value}}</span>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    }
  }
}
</script>
<style lang="less">
.basicItem-wrap{
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  >span.tag{
    display: inline-block;
  }
}
.basicItem-label{
  font-weight: 500;
}
</style>